import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import SearchResultSection from "./components/SearchResultSection";
import Loading from "../admin/childComponents/appComponents/Loading";
// import Youtube from "./components/Youtube";
// import ClientsSection from "./components/ClientsSection";
// import PhotoNewsSection from "./components/PhotoNewsSection";

function Search() {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { search } = useParams();

  const [loading, setLoading] = useState(true);

  const [readSection, setReadSection] = useState([]);
  const [downloadSection, setDownloadSection] = useState([]);

  const [pageRead, setPageRead] = useState(1);
  const [pageDownload, setPageDownload] = useState(1);

  const [readPagination, setReadPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
  });

  const [downloadPagination, setDownloadPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
  });

  /** READ SECTION **/
  const fetchRead = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${BASE_URL}posdata?page=${pageRead}&per_page=10`,
        {
          params: {
            "storyTitle[like]": `%${search}%`,
            "title[like]": `%${search}%`,
          },
        },
      );

      setReadSection(response?.data?.allData || []);
      setReadPagination(response?.data?.pagination || {});
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  /** DOWNLOAD SECTION **/
  const fetchDownload = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}posdata?columes[eq]=title_show_echo_01wa&ministry[eq]=0&status02[eq]=publish&status[eq]=Public&visibility[eq]=Public&page=${pageDownload}&per_page=10`,
      );

      setDownloadSection(response?.data?.allData || []);
      setDownloadPagination(response?.data?.pagination || {});
    } catch (error) {
      console.error(error);
    }
  };

  /** FETCH SEARCH RESULTS **/
  useEffect(() => {
    fetchRead();
  }, [search, pageRead]);

  /** FETCH DOWNLOADS **/
  useEffect(() => {
    fetchDownload();
  }, [pageDownload]);

  /** RESET PAGE WHEN SEARCH CHANGES **/
  useEffect(() => {
    setPageRead(1);
    window.scrollTo(0, 0);
  }, [search]);

  if (loading) return <Loading message01="Loading..." />;

  return (
    <>
      {readSection.length > 0 && (
        <SearchResultSection
          datacontent={readSection}
          downloadSection={downloadSection}
          pagination={readPagination}
          setPageRead={setPageRead}
          paginationDownload={downloadPagination}
          setPageDownload={setPageDownload}
        />
      )}

      {/* <PhotoNewsSection />
      <Youtube />
      <ClientsSection /> */}
    </>
  );
}

export default Search;
